import React from 'react';
import { THEME_BLACK, THEME_GREY, THEME_WARNING, themeColor } from '../../../styles/basics/colors';
import { StCampaignLabel, StCampaignValue, StLoansLeftColor } from './MetaDataStyles';
import { useTranslation } from 'react-i18next';

interface Props {
    loansLeft: number;
    totalLoans: number;
    loansAndCopiesTextGraying: boolean;
}

export const TotalLoans = (props: Props) => {
    const { t } = useTranslation();
    const loansLeft = props.loansLeft;
    const totalLoans = props.totalLoans;
    const loansAndCopiesTextGraying = props.loansAndCopiesTextGraying;

    let color: string;

    if (loansAndCopiesTextGraying) {
        color = themeColor(THEME_GREY);
    } else {
        if (loansLeft <= totalLoans / 5) {
            color = themeColor(THEME_WARNING);
        } else {
            color = themeColor(THEME_BLACK);
        }
    }

    return (
        <React.Fragment>
            <StCampaignLabel>{t('marketing.yourCampaigns.loansLeft')}:</StCampaignLabel>
            <StCampaignValue>
                <StLoansLeftColor color={color}>
                    {t('marketing.yourCampaigns.loansLeftDescription', {
                        loansLeft: loansLeft,
                        totalLoans: totalLoans
                    })}
                </StLoansLeftColor>
            </StCampaignValue>
        </React.Fragment>
    );
};
